module.exports = __webpack_public_path__ + "static/media/user-follow-color.fc257bf8.svg";